<template>
  <div style="margin-top:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">General Account Settings</span><br/>
    </div>

    <div v-if="!loading" style="text-align: left; color: #666;" class="d-flex align-items-center justify-content-center">
      <form @submit.prevent="save_config">
        <table width="90%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
          <tr>
            <td align="right" width="500">Name</td>
            <td width="800"><b-form-input v-model="model.tenant_name" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Timezone</td>
            <td width="800"><b-form-input v-model="model.timezone" type="text" :readonly="!is_admin"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Company ID</td>
            <td width="800"><b-form-input v-model="model.company_id" type="text" :readonly="!is_admin"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Phone Number</td>
            <td width="800"><b-form-input v-model="model.aws_phone_number" type="text" :readonly="!is_admin"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Vehicle Yards</td>
            <td width="800"><b-button variant="" @click="manage_sos_yards = !manage_sos_yards">Manage Yards</b-button></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Vehicle Tag Filter</td>
            <td width="800"><b-form-input v-model="model.samsara_tag_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Driver Tag Filter</td>
            <td width="800"><b-form-input v-model="model.samsara_driver_tag_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="400">Routes - Create Routes From Bookings</td>
            <td width="800"><b-form-select v-model="model.routes_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="400">Routes - Assign To Drivers</td>
            <td width="800"><b-form-select v-model="model.routes_assign_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="400">Routes - Assign To Drivers Then Vehicles</td>
            <td width="800"><b-form-select v-model="model.routes_assign_to_driver_then_vehicle" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type=='TBN'">
            <td align="right" width="400">Route - Assign Vehicles To Existing Routes</td>
            <td width="800"><b-form-select v-model="model.routes_vehicle_assignments_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Email Sender Prefix</td>
            <td width="800"><b-form-input v-model="model.email_sender_prefix" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Email Response Forward Address</td>
            <td width="800"><b-form-input v-model="model.email_response_forward_address" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Email Response Forward Filters</td>
            <td width="800"><b-form-input v-model="model.email_response_forward_filters" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">SMS Response Email Recipients</td>
            <td width="800"><b-form-input v-model="model.sms_response_email_recipients" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">SMS Response Text</td>
            <td width="800"><b-form-input v-model="model.sms_response_text" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Support Ticket Approvers (CC'd on all tickets)</td>
            <td width="800"><b-form-input v-model="model.support_ticket_approver_emails" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="is_admin">
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isAdvVisible')">+ Advanced</span></td>
            <td></td>
            <td></td>
          </tr>
          <template v-if="toggle.isAdvVisible">
            <tr>
              <td align="right" width="500">Active</td>
              <td width="800"><b-form-select v-model="model.active" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Org ID</td>
              <td width="800"><b-form-input v-model="model.org_id" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Group ID</td>
              <td width="800"><b-form-input v-model="model.group_id" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">API Key</td>
              <td width="800"><b-form-input v-model="model.api_key" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="isDevEnvironment()">
              <td align="right" width="500">Allowed Email Receipients</td>
              <td width="800"><b-form-input v-model="model.allowed_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="isDevEnvironment()">
              <td align="right" width="500">Allowed SMS Receipients</td>
              <td width="800"><b-form-input v-model="model.allowed_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="isDevEnvironment()">
              <td align="right" width="500">Allowed Booking Ids</td>
              <td width="800"><b-form-input v-model="model.process_booking_ids" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          </table>

        <hr/>
        <div style="position: relative" class="d-flex align-items-center justify-content-center">
          <b-btn size="lg" type="submit" variant="success" id="save-user-submit">Save</b-btn>
          &nbsp;&nbsp;<b-btn size="lg" @click="load_data()">Cancel</b-btn>
        </div>

      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  <b-modal title="Manage Vehicle Yards" size="xl" v-model="manage_sos_yards" ok-only>
    <b>Found {{yardsLength}} Yards - these are used to support the BUS SOS and Vehicle Status Management features.</b><br/><br/>
    <div v-if="loading">
      <b-spinner style="width: 1rem; height: 1rem;" label="Loading..."></b-spinner>
    </div>
    <div v-else>
      <b-table v-if="model.vehicle_yards" :items="model.vehicle_yards" :fields="['yard_name','address','contact_name','phone','email','timezone','remove']">
        <template slot="address" slot-scope="row">
          <a target='_blank' :href="'https://www.google.com/maps/search/?api=1&query=' + row.item.lat + ',' + row.item.lon">{{row.item.address}}</a>
          <br/>[<a target="_blank" :href="'./#/fleet-track/' + user.tenant + '/yard/' + row.item.yard_name.replaceAll(' ','+')">show yard map</a>]
        </template>
        <template slot="remove" slot-scope="row">
          <b-button size="sm" @click="delete_yard(row.item.yard_name)">remove</b-button>
        </template>
      </b-table>
      <hr/>
      <div style="font-weight: bold; font-size: 18px;" v-on:click="toggle_div(toggle,'isAddYardVisible')">&#43; Add New Yard</div><br/>
       <span :style="toggle.isAddYardVisible ? '' : 'display:none'">
          <div>
            Yard Name: <b-form-input v-model="add_yard_model.yard_name" required/>
            Address: <b-form-input v-model="add_yard_model.address" required/>
            Contact Name: <b-form-input v-model="add_yard_model.contact_name" required/>
            Phone: <b-form-input v-model="add_yard_model.phone" required/>
            Email: <b-form-input v-model="add_yard_model.email" required/>
            Timezone: <b-form-input v-model="add_yard_model.timezone" required/>
          </div><br/>
          <b-button v-if="!loading" variant="success" size="sm" @click="add_yard()">Save Yard</b-button>
        </span>
     </div>
  </b-modal>
</div>

</template>
<script>
import {add_yard, delete_yard, get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";

export default {
  name: 'tenant_config',
  components: {
  },

  data() {
    return {
      group_name: 'general',
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      toggle: {},
      summary: {},
      loading: true,
      yardsLength: 0,
      objectKeyList:[],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async delete_yard(yard_name) {
      this.loading=true
      await delete_yard(this.user.tenant, yard_name)
      await this.load_data()
    },
    async add_yard() {
      this.loading=true
      await add_yard(this.user.tenant, this.add_yard_model)
      this.add_yard_model = {}
      this.toggle_div(this.toggle, 'isAddYardVisible')
      await this.load_data()
    },
    async hosModalOk($event) {
      this.add_event_model = {}
      this.update_toggle_div(this.toggle, 'isAddEventVisible', false)
    },

    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        if (!this.model.vehicle_yards)
          this.model.vehicle_yards = []

        this.yardsLength = this.model.vehicle_yards.length
        if (this.model.vehicle_yards == '[]')
          this.model.vehicle_yards = []
        
        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }
        try {
          if (this.model.vehicle_yards != "" && this.model.vehicle_yards != null) {
            this.model.vehicle_yards = JSON.parse(this.model.vehicle_yards);
          } else {
            this.model.vehicle_yards = []
          }
        } catch(e) {
          console.log('exception converting hos alert settings to json:' + e)
        }

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async get_yard_length(model) {
      this.yardsLength = model.vehicle_yards.length
    },
    async save_config() {
      try {
        window.scrollTo(0,0);
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        //return value to object 
        //console.log("this.objectKeyList: " + JSON.stringify(this.objectKeyList))
        for (const objkey of this.objectKeyList) {
          try {
            let setting = JSON.parse(this.model[objkey])
            this.model[objkey] = setting
          } catch (e) {
            console.log('exception parsing object keys for objkey:' + objkey, e)
          }
        }
        await update_tenant_config_settings(this.user.tenant, this.model, this.group_name)
        this.load_data()
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    isPlainObject(value,key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
    isDevEnvironment() {
      return (process.env.VUE_APP_API_URL.includes('dev-web') || process.env.VUE_APP_API_URL.includes('localhost'))
    }
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>

